import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderModule } from '../../header';
import { SiteNavigationModule } from '../../site-navigation';
import { DirectivesModule } from '../Directives';
import { GlobalNavModule } from '../global-nav';
import { LegacySpaNavComponent } from './legacy-spa-nav-menu.component';
import { PIUniversalNavComponent } from './pi-universal-nav.component';

@NgModule({
    declarations: [PIUniversalNavComponent, LegacySpaNavComponent],
    imports: [
        CommonModule,
        GlobalNavModule,
        SiteNavigationModule,
        HeaderModule,
        DirectivesModule
    ],
    exports: [PIUniversalNavComponent, LegacySpaNavComponent]
})
export class PIUniversalNavModule {}
